import React from 'react';
import { DollarSign, TrendingUp, Activity, Users } from 'lucide-react';
import type { UserPerformanceData } from '../../lib/types';
import { MetricCard } from './MetricCard';
import { formatCurrency, formatPercentage } from './formatters';

interface TraderPerformanceSummaryProps {
  users: UserPerformanceData[];
}

export const TraderPerformanceSummary: React.FC<TraderPerformanceSummaryProps> = ({ users }) => {
  return (
    <div className="bg-white shadow rounded-lg">
      <div className="px-6 py-4 border-b border-gray-200">
        <h2 className="text-lg font-semibold text-gray-900">Trader Performance Summary</h2>
        <p className="text-sm text-gray-600 mt-1">Individual trader performance metrics</p>
      </div>
      <div className="p-6">
        <div className="space-y-6">
          {users.map((user) => (
            <div key={user.userId} className="border border-gray-200 rounded-lg p-4">
              <h3 className="text-lg font-medium text-gray-900 mb-4">{user.userName}</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                <MetricCard
                  title="Total P&L (USDT)"
                  value={formatCurrency(user.totalPnl)}
                  icon={<DollarSign className="h-5 w-5" />}
                  trend={user.totalPnl > 0 ? 'up' : user.totalPnl < 0 ? 'down' : 'neutral'}
                  description={`${user.totalTrades} trades`}
                />
                <MetricCard
                  title="Win Rate"
                  value={formatPercentage(user.winRate)}
                  icon={<TrendingUp className="h-5 w-5" />}
                  trend={user.winRate > 50 ? 'up' : 'down'}
                  description="Success rate"
                />
                <MetricCard
                  title="Total Volume"
                  value={formatCurrency(user.totalVolume)}
                  icon={<Activity className="h-5 w-5" />}
                  description="Trading volume"
                />
                <MetricCard
                  title="Avg Trade Size"
                  value={formatCurrency(user.averageTradeSize)}
                  icon={<Users className="h-5 w-5" />}
                  description="Average trade value"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
